import React from 'react';
import { bodyTextRenderOptions } from '@/contentful/helper';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import './_page-alert.scss';

interface IProps {
  alert?: any;
  display?: boolean;
}

const PageAlert = (props: IProps) => {
  const { alert } = props;

  return (
    <>
      {(alert?.showAlert || props.display) && (
        <div className="d-flex justify-content-center mb-5 mt-5">
          <div className={`page-alert ys-notification ${'ys-notification--' + alert?.type}`}>
            <span className="ys-notification__icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 12">
                <g fill="none" fillRule="evenodd">
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 1v6"
                  />
                  <path fill="currentColor" d="M2 11a1 1 0 11-2 0 1 1 0 012 0" />
                </g>
              </svg>
            </span>
            <div className="ys-notification__content">
              {(alert?.content?.json && (
                <div className="ys-notification__text">
                  {' '}
                  {documentToReactComponents(alert?.content?.json, bodyTextRenderOptions)}
                </div>
              )) || (
                <div className="ys-notification__text">
                  <p className="contentful__body-text">
                    Vi har i øjeblikket en fejl der gør, at oplevelsen ikke er som den plejer.
                    <br />
                    <br />
                    <b>Vi hjælper dig gerne over telefonen.</b>
                  </p>
                  <p className="contentful__body-text">
                    <a
                      className="ys-link"
                      href="https://kampagne.yousee.dk/simo-rej-rmo"
                      target="https://kampagne.yousee.dk/simo-rej-rmo"
                      rel="https://kampagne.yousee.dk/simo-rej-rmo"
                    >
                      Ring mig op
                    </a>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PageAlert;
